import React from "react";
import TakeawayOrderEditor from "./TakeawayOrderEditor";

const DineInOrderEditor = () => {
  return <TakeawayOrderEditor entryVariant="DINE_IN" showHeader={false} />;
};

export default DineInOrderEditor;

